module.exports = __webpack_public_path__ + "media/images/emblems/Oberbalm-coat_of_arms-931857182ca1b997eb5bb2378caa57d4.svg";